import React, { useContext, useEffect, useState, useCallback } from "react";

import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { StateContext as HomeStateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import {
  callApi,
  getDwk,
  timeFormat,
  isTodayObject,
  recoverTag,
  convertMinutes,
} from "bodycodi/cmap/app/js/common";
import ClassNotice from "./classNotice";
import InfoPop from "./infoPop";
import ShceduleClassStep, {
  AttendanceConfirm,
  ScheduleClassResult,
  AbsentConfirm,
  ScheduleClassResultAbsent,
  ClassAttendantCnt,
  AttendanceConfirmOne,
  AbsentConfirmOne,
  RsrvCancleConfirm,
  RsrvCancleConfirmOne,
  ClassRsrvCancleResult,
} from "./scheduleClassStep";
import PopupHeader from "bodycodi/cmap/app/components/cmap2020/scheduleDtlHeader";
import more from "bodycodi/cmap/app/img/rsrv-more-btn.png";
import ClassMemberList from "bodycodi/cmap/app/components/cmap2020/ClassMemberList";
import ClassWaitingMember from "bodycodi/cmap/app/components/cmap2020/ClassWaitingMember";
import ViewAllRsrvMember from "bodycodi/cmap/app/components/cmap2020/viewAllRsrvMember";
import LoadingSpinner from "bodycodi/cmap/app/components/common/loadingSpinner";

type ClassMemberProp = {
  PartnerClassScheduleVO: any;
  NoSeatMemberList: any;
  RsrvMemberList: any;
  WaitMemberList: any;
  openClassScheduleBtn: Function;
  clickedMembers: any;
  setClickedMembers: any;
  setNaverMemberSelected: any;
};

const ClassDtlPop = () => {
  const { state } = useContext(HomeStateContext);
  const { dispatch } = useContext(DispatchContext);
  const [scheduleData, setScheduleData] = useState<any>({
    PartnerClassScheduleVO: {},
    RsrvMemberList: [],
    WaitMemberList: [],
    NoSeatMemberList: [],
    PassVO: {},
  });
  const [ResultMemberList, setResultMemberList] = useState([]);
  const [refresh, setRefresh] = useState(1);
  const [loading, setLoading] = useState(false);
  const [clickedMembers, setClickedMembers] = useState<any[]>([]);
  const [naverMemberSelected, setNaverMemberSelected] = useState<boolean>(false);
  const { NoSeatMemberList, PartnerClassScheduleVO, RsrvMemberList } = scheduleData;
  const startDate = new Date(PartnerClassScheduleVO.startDt);
  const today = isTodayObject(startDate);
  const startDateText = startDate?.getMonth() + 1 + ". " + startDate.getDate();
  const startTime = timeFormat(PartnerClassScheduleVO.startTime);
  const endTime = timeFormat(PartnerClassScheduleVO.endTime);

  useEffect(() => {
    callApi(
      "/cmap2030/viewClassScheduleDtl",
      {
        seqPartner: state.scheduleDtlPop.seqPartner,
        seqPartnerBranch: state.scheduleDtlPop.seqPartnerBranch,
        seqPartnerCoach: state.scheduleDtlPop.seqPartnerCoach,
        seqPartnerClassSchedule: state.scheduleDtlPop.seqPartnerClassSchedule,
        scheduleType: state.scheduleDtlPop.scheduleType,
      },
      "GET"
    ).then((res) => {
      setScheduleData({ ...scheduleData, ...res });
      setLoading(true);
    });
  }, [refresh]);

  const update = useCallback(() => {
    setRefresh(refresh + 1);
  }, [refresh]);

  const handleClose = useCallback(() => {
    dispatch({ type: "POP_UP_OPEN", id: "SCHEDULE_DTL_POP", open: { scheduleDtlPop: false } });
  }, []);

  const openClassScheduleBtn = () => {
    if (naverMemberSelected) {
      dispatch({
        type: "ALERT_SETTING",
        data: {
          alert: true,
          header: "그룹수업 출결 처리",
          body: `네이버 예약은 출결석 처리를 할 수 없습니다.\n 바디코디 CRM으로 출결석 처리바랍니다.`,
          redYn: false,
          cancleYn: false,
          cancelAlert: () => {},
          closeAlert: () => {},
        },
      });
      return;
    }

    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_BTN_POP",
      open: { classScheduleBtnPop: true },
    });
  };

  const handleClickInfo = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SCHDULE_DTL_INFO_POP",
      open: { scheduleDtlInfoPop: true },
    });
  };

  if (!loading) {
    return (
      <>
        <PopupHeader
          title="그룹수업 스케줄"
          rightIconType="info"
          onClickBack={handleClose}
          onClickRightIcon={handleClickInfo}
        />
        <div className="message-pop-loading">
          <LoadingSpinner />
        </div>
      </>
    );
  }

  return (
    <>
      <PopupHeader
        title="그룹수업 스케줄"
        rightIconType="info"
        onClickBack={handleClose}
        onClickRightIcon={handleClickInfo}
      />
      <div className="popup-body ap-dtl-pop">
        {loading && (
          <>
            <div className="date-wrap">
              <div className="date">
                <span>
                  {startDateText}. {getDwk(startDate.getDay())}
                </span>
                {today && <> &#183; 오늘</>}
              </div>
              <div className="time">
                {startTime.ampm} {startTime.time} - {endTime.ampm} {endTime.time}
              </div>
            </div>

            {PartnerClassScheduleVO?.closeYn === "Y" && ( // 폐강된 스케줄
              <div className="auto-close-info">
                <span className="title">
                  🚨 수업 인원 미달로 해당 수업은 <b>자동 폐강</b> 되었습니다.
                </span>

                <div className="content">
                  <span>수업일 기준</span>
                  <span>
                    {`${convertMinutes(PartnerClassScheduleVO?.autoCancelSettingTime)} 전 까지`}
                  </span>
                </div>

                <div className="content">
                  <span>최소 수강 인원</span>
                  <span>{PartnerClassScheduleVO?.autoCancelSettingCount}명 미달 시</span>
                </div>
              </div>
            )}

            <ClassMember
              {...scheduleData}
              memberList={clickedMembers}
              openClassScheduleBtn={openClassScheduleBtn}
              refresh={refresh}
              clickedMembers={clickedMembers}
              setClickedMembers={setClickedMembers}
              setNaverMemberSelected={setNaverMemberSelected}
            />
          </>
        )}

        {PartnerClassScheduleVO?.closeYn === "Y" ? (
          <div className="schedule-pop-btn purple">폐강된 스케줄은 출결처리가 불가능합니다.</div>
        ) : NoSeatMemberList.concat(RsrvMemberList).length === 0 ? (
          <div className="schedule-pop-btn-disable">
            예약한 회원이 있어야 출결처리 할 수 있어요!
          </div>
        ) : clickedMembers.length === 0 ? (
          <div className="schedule-pop-btn-disable">출결 처리할 회원을 선택해주세요!</div>
        ) : (
          <div className="schedule-pop-btn class" onClick={openClassScheduleBtn}>
            출결 처리하기
          </div>
        )}
      </div>
      <InfoPop />
      {/* 출석 처리하기 */}
      <ShceduleClassStep memberList={clickedMembers} />
      {/* 그룹수업 참여 회원수 입력 */}
      <ClassAttendantCnt PartnerClassScheduleVO={PartnerClassScheduleVO} update={update} />
      {/* 여러명 출석/결석/취소 */}
      <AttendanceConfirm
        memberList={clickedMembers}
        PartnerClassScheduleVO={PartnerClassScheduleVO}
        setResultMemberList={setResultMemberList}
        update={update}
      />
      <AbsentConfirm
        memberList={clickedMembers}
        PartnerClassScheduleVO={PartnerClassScheduleVO}
        setResultMemberList={setResultMemberList}
        update={update}
      />
      <RsrvCancleConfirm
        memberList={clickedMembers}
        update={update}
        PartnerClassScheduleVO={PartnerClassScheduleVO}
        setResultMemberList={setResultMemberList}
      />
      {/* 여러명 출석/결석/취소 처리 결과 */}
      <ScheduleClassResult
        memberListCnt={clickedMembers.length}
        ResultMemberList={ResultMemberList}
        setClickedMembers={setClickedMembers}
      />
      <ScheduleClassResultAbsent
        memberListCnt={clickedMembers.length}
        ResultMemberList={ResultMemberList}
        setClickedMembers={setClickedMembers}
      />
      <ClassRsrvCancleResult
        memberListCnt={clickedMembers.length}
        ResultMemberList={ResultMemberList}
        setClickedMembers={setClickedMembers}
      />
      {/* 한명 출석/결석/취소 */}
      {clickedMembers.length === 1 && (
        <>
          <AttendanceConfirmOne
            d={clickedMembers[0]}
            setClickedMembers={setClickedMembers}
            update={update}
            PartnerClassScheduleVO={PartnerClassScheduleVO}
          />
          <AbsentConfirmOne
            d={clickedMembers[0]}
            setClickedMembers={setClickedMembers}
            update={update}
            PartnerClassScheduleVO={PartnerClassScheduleVO}
          />
          <RsrvCancleConfirmOne
            d={clickedMembers[0]}
            setClickedMembers={setClickedMembers}
            update={update}
            PartnerClassScheduleVO={PartnerClassScheduleVO}
          />
        </>
      )}
    </>
  );
};

const ClassMember = ({
  PartnerClassScheduleVO,
  NoSeatMemberList,
  RsrvMemberList,
  WaitMemberList,
  openClassScheduleBtn,
  clickedMembers,
  setClickedMembers,
  setNaverMemberSelected,
}: ClassMemberProp) => {
  const { dispatch } = useContext(DispatchContext);
  const cntAllMember =
    PartnerClassScheduleVO.reservationLimitNo > 16
      ? PartnerClassScheduleVO.reservationLimitNo
      : RsrvMemberList.concat(NoSeatMemberList).length;

  const handleClickViewAllMember = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "VIEW_ALL_RSRV_MEMBER_POP",
      open: { viewAllRsrvMemberPop: true },
    });
  };
  const handleClickMember = (d: any) => {
    const isIncludeMember = clickedMembers.some((v: any) => v.seqMember === d.seqMember);
    const isNaverMember = d.seqMember === 0 && d.naverBookingY;
    if (isIncludeMember) {
      setClickedMembers((previousValue: any) =>
        previousValue.filter((v: any) => v.seqMember !== d.seqMember)
      );
      if (isNaverMember) setNaverMemberSelected(false);
    } else {
      if (clickedMembers.length === 10) {
        dispatch({
          type: "UPDATE",
          data: {
            toast: true,
            toastText: `한번에 최대 10명까지 출결 처리할 수 있어요.`,
          },
        });
        return;
      }
      setClickedMembers((previousValue: any) => previousValue.concat(d));
      if (isNaverMember) setNaverMemberSelected(true);
    }
  };

  return (
    <>
      <div className="schedule-card class">
        <div className="schedule-type">
          <div>그룹수업</div>

          {PartnerClassScheduleVO?.closeYn === "Y" ? (
            <span className="auto-close-badge">폐강</span>
          ) : (
            <span className="black">
              정원 {PartnerClassScheduleVO.reservationLimitNo}
              {PartnerClassScheduleVO.reservationPsblTimeYn === "Y" && (
                <>
                  {PartnerClassScheduleVO.recruitYn === "Y" && (
                    <>
                      <span className="slash"> | </span>
                      <span className="blue">모집중</span>
                    </>
                  )}
                  {PartnerClassScheduleVO.recruitYn === "N" && (
                    <>
                      <span className="slash"> | </span>
                      <span className="green">모집완료</span>
                    </>
                  )}
                </>
              )}
            </span>
          )}
        </div>
        <div className="schedule-name">{recoverTag(PartnerClassScheduleVO.lessonName)}</div>
        <div className="schedule-partner">
          {PartnerClassScheduleVO.partnerName} {PartnerClassScheduleVO.companyName} &#183;{" "}
          {PartnerClassScheduleVO.spaceName}
        </div>
      </div>
      <div className="schedule-state-wrap">
        <div className="schedule-state">
          <span className="blue">예약 {PartnerClassScheduleVO.reservationNo}</span>
          <span className="red">결석 {PartnerClassScheduleVO.absenceNo}</span>
          <span className="green">출석 {PartnerClassScheduleVO.attendanceNo}</span>
          {PartnerClassScheduleVO?.closeYn === "Y" ? (
            <span className="purple">폐강 {PartnerClassScheduleVO?.closeNo}</span>
          ) : (
            <span className="gray">대기 {PartnerClassScheduleVO.waitNo}</span>
          )}
        </div>

        <ClassMemberList
          isWatingMember={false}
          isLimit={true}
          isSeatClass={PartnerClassScheduleVO.totalSeat > 0}
          classMemberList={RsrvMemberList.concat(NoSeatMemberList)}
          clickedMembers={clickedMembers}
          reservationLimitNo={PartnerClassScheduleVO.reservationLimitNo}
          onClickMember={handleClickMember}
        />
        {cntAllMember > 16 && (
          <>
            <div className="rsrv-member-more-btn" onClick={handleClickViewAllMember}>
              현황 전체보기
              <img src={more} />
            </div>
            <ViewAllRsrvMember
              isSeatClass={PartnerClassScheduleVO.totalSeat > 0}
              RsrvMemberList={RsrvMemberList.concat(NoSeatMemberList)}
              reservationLimitNo={PartnerClassScheduleVO.reservationLimitNo}
              clickedMembers={clickedMembers}
              handleClickMember={handleClickMember}
              openClassScheduleBtn={openClassScheduleBtn}
            />
          </>
        )}
      </div>
      <ClassWaitingMember waitMemberList={WaitMemberList} />
      <ClassNotice PartnerClassScheduleVO={PartnerClassScheduleVO} />
    </>
  );
};

export default ClassDtlPop;
